import { BookingRequestsStatus } from "../../../components/BookingRequest/typings/booking-requests.types";
import { BookingScheduleInterface } from "./booking.types";

export enum ServiceType {
  Catering = "catering",
  Bookable_Equipment = "bookable_equipment",
  Room_Layout = "room_layout"
}

export enum ServiceDeliveryStatus {
  ORDERED = "RECEIVED",
  IN_PROGRESS = "IN_PROGRESS",
  READY = "READY" // DELIVERED = "DELIVERED"
}

export interface ServicesZoneBooking {
  id: number;
  serviceType: ServiceType;
  serviceId: number;
  setUpTime: number;
  bookingLeadTime?: number; // later, remove undefined case
  qty: number;
  status: BookingRequestsStatus | null;
  deliveryStatus: ServiceDeliveryStatus | null;
  statusChangedDate: Date;
  booking: NoPlaceZoneBooking;
  bookingId: number;
  orderedQty: number;
  availableQty: number | null;
}

/** no place zone (conference zone, etc) booking interface, mainly used for booking service administration */
export interface NoPlaceZoneBooking extends BookingScheduleInterface {
  serviceBookings: ServicesZoneBooking[];
  // initialTodayPastStartTime: Date | null;
  // initialTodayPastEndTime: Date | null;
  // bookingInventory: ZoneInventory;
  // visitors: NoPlaceZoneBookingVisitors[];
  // attachments: NoPlaceZoneBookingAttachment[];
}

export type UpdateBookingServicesDto = {
  serviceType: ServiceType;
  status: BookingRequestsStatus;
  deliveryStatus: ServiceDeliveryStatus;
  serviceBookingId: number;
  serviceId: number;
  bookingId: number;
  setUpTime: number;
  qty?: number;
};
